<div
  class="ion-no-padding padt10 ion-padding-horizontal ion-padding-bottom marb5"
>
  <div class="scrollx no-scroll ion-no-padding ion-no-margin">
    <div class="scroll-item" *ngFor="let item of productsList">
      <ion-card>
        <ion-chip
          class="ion-no-padding ion-no-margin fs-1 font500 ion-text-center tertiary-chip"
          *ngIf="item?.offerTag"
        >
          {{ item?.offerTag }}</ion-chip
        >
        <ion-img
          [src]="item.img || imagePlaceholder"
          (ionError)="item.img = imagePlaceholder"
          (click)="navigateToProduct(item)"
          class="product-img"
          style="cursor: pointer"
        >
        </ion-img>
        <ion-card-header class="ion-padding-horizontal ion-no-padding">
          <ion-card-title text-wrap class="fs-1 font500">
            <div class="line-clamp-2 ion-text-wrap card-primary-text-color">
              {{ item.title }}
            </div>
          </ion-card-title>
          <div class="card-content">
            <ion-text>
              <h5
                class="orig-price mart5 marr10 strike-price-color ion-no-margin fs-2 font600"
                *ngIf="item.finalPrice < item.origPrice"
              >
                {{ item.origPrice | currency : currencyCode }}
              </h5>
              <h5
                class="final-price mart5 primary-price-color ion-no-margin fs-3 font600"
              >
                {{ item.finalPrice | currency : currencyCode }}
              </h5>
              <h5
                class="red-text-color ion-no-margin fs-1 font500"
                *ngIf="item.discount > 0"
              >
                {{ item.discount }}%
                {{ "shared.product_card_list.off" | translate }}
              </h5>
            </ion-text>
          </div>
        </ion-card-header>
      </ion-card>
    </div>
  </div>
</div>
